jQuery(document).ready(function ($) {
    var today = new Date().toISOString().slice(0, 10); // Get today's date in YYYY-MM-DD format

    $('#rubrique-filter').on('change', function () {
        var selectedRubrique = $(this).val();

        // Modify the query args based on the selected rubrique filter
        var args = {
            post_type: 'evenements',
            posts_per_page: -1,
            meta_query: [
                {
                    key: 'date',
                    value: today,
                    compare: '>=', // Select events with dates greater than or equal to today
                    type: 'DATE',
                },
            ],
            tax_query: [],
        };

        if (selectedRubrique) {
            args.tax_query.push({
                taxonomy: 'rubriques', // Replace with the actual taxonomy name
                field: 'slug',
                terms: selectedRubrique,
            });
        }

        // Perform the query using AJAX
        $.ajax({
            url: rubrique_filter_params.ajaxUrl, // Use the correct AJAX URL
            data: {
                action: 'filter_events',
                rubrique_filter: args.tax_query.length > 0 ? args.tax_query[0].terms : '', // Include the selected rubrique in the data
            },
            type: 'POST',
            success: function (response) {
                $('#listing_evenements').html(response);
            }
        });
    });
});
